import { Card, Col, Row, Button } from 'antd'
import React, { useEffect } from 'react'
import './helpAndSupport.scss'
import { Link, useOutletContext } from 'react-router-dom'
import telegram from '../../assets/TelegramLogo.svg'
import twitter from '../../assets/x-logo.webp'
import chat from '../../assets/ChatsCircle.svg'

const ROOT = `dashboard_help`

export default function HelpAndSupport(props) {
  const { setHeaderTitle } = props
  const outletProps = useOutletContext()
  const { cardBackgroundColor } = outletProps

  const faqs = [
    {
      question: 'What is the campaign duration for the Joining the Waitlist and Refer & Earn program?',
      answer: 'The campaign duration for the Joining the Waitlist and Refer & Earn program is currently set to 30 days. Please note that this duration may be subject to change, so make sure to stay updated through our official channels.',
    },
    {
      question: 'How much is the total pool allocated for the Joining the Waitlist and Refer & Earn program?',
      answer: 'The total pool for this campaign is $150,000, which will be distributed in the form of tokens equivalent to 1.25 Mn $BAAI tokens.',
    },
    {
      question: 'What will I receive for joining the waitlist?',
      answer: 'You will earn up to 28 $BAAI tokens for signing up using your email and joining the waitlist. A detailed guide to distribution can be found in the',
      blog :'blog'
      
    },
    {
      question: 'How does the Refer & Earn mechanism work?',
      answer: 'Under the Refer & Earn mechanism, you will earn up to 28 $BAAI tokens for every successful referral you make. Your referrals need to successfully join the waitlist for you to receive the reward. A detailed guide to distribution can be found in the',
      blog :'blog'
    },
    {
      question: 'Are the earned tokens tradeable?',
      answer: 'The tokens earned through this waitlist campaign are non-tradable right now. They will be displayed in your dashboard. However, post our token launch which is planned for Q4, 23 (subject to market conditions), you will be able to trade them on leading exchanges.',
    },
    {
      question: 'At what price are the airdrop rewards for this campaign calculated?',
      answer: 'All the airdrop rewards are calculated based on the public listing price of $BAAI tokens, which is set at $0.12.',
    },
    {
      question: 'How will I know if my referral was successful?',
      answer: 'You will be notified through your registered email or dashboard once your referral successfully joins the waitlist. At that point, you will receive the Refer & Earn reward.',
    },
    {
      question: 'What if I refer to a user who is already on the waitlist?',
      answer: 'Referring someone who is already on the waitlist will not count as a successful referral. To earn rewards, you need to refer new users who join the waitlist.',
    },
    {
      question: "How can I track the number of referrals I've made and my rewards?",
      answer: "You can track the number of successful referrals you've made and your rewards through your dashboard. The information will be updated in real-time. There will be a leaderboard that displays the top referrers.",
    },
    {
      question: "Any other eligibility criteria?",
      answer: "All the users need to join our Telegram channel and follow us on Twitter to be eligible for the reward pool.",
    },
  ]

  useEffect(() => {
    // Update the header title when the component mounts
    setHeaderTitle('Help & Support')
    return () => {
      // Optionally, reset the header title when the component unmounts
      setHeaderTitle('')
    }
  }, [setHeaderTitle])

  return (
    <div
      className={`${ROOT}__card_ui px-4 py-5`}
      style={{ backgroundColor: 'white' }}
    >
      <Card style={{ backgroundColor: `${cardBackgroundColor}` }}>
        <Row align="middle">
          <Col
            lg={14}
            xs={24}
          >
            <h4>Join our Community</h4>
            <p>Join our community channels and stay up to date about news and updates about our products and campaigns.</p>
          </Col>
          <Col
            lg={10}
            xs={24}
          >
            <Row
              className="justify-content-end"
              gutter={[10, 10]}
            >
              <Col>
                {' '}
                <Link
                  to="https://t.me/Braina_Live"
                  target="_blank"
                >
                  <Button
                    className="top-button"
                    type="primary"
                    size="large"
                    style={{ fontSize: '13px' }}
                  >
                    Join us on Telegram
                    <img
                      className="mx-2"
                      src={telegram}
                      alt="Join telegram"
                      style={{ width: '24px', height: '24px' }}
                    />
                  </Button>
                </Link>
              </Col>
              <Col>
                <Link
                  to="https://twitter.com/BrainAlive_AI"
                  target="_blank"
                >
                  <Button
                    className="top-button"
                    type="primary"
                    size="large"
                    style={{ fontSize: '13px' }}
                  >
                    Follow us on Twitter
                    <img
                      className="mx-2"
                      src={twitter}
                      alt="Join telegram"
                      style={{ width: '24px', height: '24px' }}
                    />
                  </Button>
                </Link>
              </Col>
            </Row>
          </Col>
        </Row>
      </Card>
      <div className="my-4">
        <h4>Frequently Asked Questions</h4>
        <p>Everything you need to know about our product and referral program</p>
      </div>
      <Row
        // justify="space-evenly"
        gutter={{
          xs: 8,
          sm: 16,
          md: 24,
          lg: 32,
        }}
      >
        {faqs.map((item, index) => {
          return (
            <Col
              key={index}
              className="gutter-row py-3"
              lg={8}
              xs={24}
              sm={24}
            >
              <Card style={{ backgroundColor: `${cardBackgroundColor}`, minHeight: '180px', height: '100%' }}>
                <h6 className="mb-3">{item.question}</h6>
                <p>
                  {item.answer}{' '}
                  <a
                    target="blank"
                    href="https://medium.com/@BrainaliveAI/baais-waitlist-campaign-win-rewards-worth-150-000-19d13730a1b3"
                  >
                    {item.blog}
                  </a>
                </p>
              </Card>
            </Col>
          )
        })}
      </Row>{' '}
      <Card
        style={{ backgroundColor: `${cardBackgroundColor}` }}
        className="mt-4"
      >
        <Row align="middle">
          <Col lg={16}>
            <h4>Still have questions?</h4>
            <p>Can’t find the answer you’re lookign for? Send us your question and we’ll answer you back asap.</p>
          </Col>
          <Col
            lg={8}
            className="d-flex justify-content-end"
          >
            <Link to="mailto:support@braina.live">
              <Button
                className="top-button"
                type="primary"
                size="large"
                style={{ fontSize: '16px' }}
              >
                Get in touch
                <img
                  className="mx-2"
                  src={chat}
                  alt="Get in touch"
                  style={{ width: '24px', height: '24px' }}
                />{' '}
              </Button>
            </Link>
          </Col>
        </Row>
      </Card>
      <div className="py-4 footer-link">
        <Link
          to="/terms"
          target="_blank"
        >
          Terms & Conditions
        </Link>
        <Link
          to="/privacy"
          target="_blank"
        >
          Privacy Policies
        </Link>
      </div>
    </div>
  )
}
